import React, { useCallback, useState } from "react";

import { Loading, PaypalButton } from "../components";
import { usePaypalApi } from "../hooks";
import EnterCoupon from "./EnterCoupon.js";
import SoldOut from "./SoldOut.js";
import useData from "./useData.js";
import useSave from "./useSave.js";

export function BookingEngine(props) {
  const {
    className,
    node = window.NODE,
    date,
    "date-formatted": dateFormatted,
    "date-human": dateHuman,
    seats,
    code,
    "code-price": codePrice,
    price,
    thankyou,
  } = props;

  const [couponvalid, setCouponvalid] = useState();
  const paypal = usePaypalApi();

  const nodev2 = useData(
    date,
    dateFormatted,
    dateHuman,
    seats,
    node,
    code,
    codePrice,
    price,
    thankyou
  );

  const { error, success, mutation, setError, onCompleted } = useSave(nodev2);
  const loading = mutation[1].loading;

  const {
    hasBookingCoupon,
    couponPrice,
    bookingCost,
    bookingDateFormatted,
    bookingDateHuman,
    bookingSeats,
    bookingSuccessMessage,
  } = nodev2;

  const databaseId = node?.databaseId;

  const onError = useCallback(
    (error) => {
      setError(error);
    },
    [setError]
  );

  if (!paypal) {
    return null;
  }

  if (!bookingDateFormatted) {
    return null;
  }

  if (bookingSeats === 0) {
    return <SoldOut />;
  }

  let seatsBg = "green";

  if (bookingSeats < 5) {
    seatsBg = "primary";
  }

  if (bookingSeats < 3) {
    seatsBg = "red";
  }

  return (
    <div {...{ className }}>
      <div className="tc shadow-4 pa4 mv4 mw6 center lh-solid relative z-1">
        {error && <div className="f4 bg-red white pa2 mb3">{error}</div>}
        {success && (
          <div className="f4 bg-green white pa2 mb3">
            {bookingSuccessMessage || "Thank You!"}
          </div>
        )}

        <div>Our Next Class is Scheduled For</div>
        <div className="f1 fw7 mv1">{bookingDateFormatted}</div>
        <div className="moon-gray">{bookingDateHuman}</div>

        <div
          className={`absolute top-0 right-0 bg-${seatsBg} white br-pill pa2 nt2 nr1 shadow-4`}
        >
          {bookingSeats} Spots Remaining
        </div>

        <div className="flex items-end mw5 center mt4">
          <div>Price:</div>
          <div className="flex-auto b--dotted b--moon-gray bl-0 br-0 bt-0 mh2" />
          <div className="f4 bg-primary br-pill pv2 ph3 fw7 v-mid">
            {couponvalid ? couponPrice : bookingCost}
          </div>
        </div>

        {hasBookingCoupon && (
          <EnterCoupon
            date={date}
            className="mv3"
            setCouponvalid={setCouponvalid}
            postId={databaseId}
          />
        )}

        {paypal && bookingDateHuman?.includes(" left") && (
          <div className="mt4">
            <PaypalButton
              amount={couponvalid ? couponPrice : bookingCost}
              {...{ paypal, onCompleted, onError }}
            />
          </div>
        )}

        {loading && <Loading />}
      </div>
    </div>
  );
}
